import React from "react";

interface IV2LogoIconProps {
  width?: number;
  height?: number;
}

const V2LogoIcon: React.FC<IV2LogoIconProps> = ({
  width = 50,
  height = 50,
}) => {
  return (
    <img
      src={`https://${process.env.NEXT_PUBLIC_WWW_DOMAIN}/v2/logo.png`}
      width={width}
      height={height}
      alt="LogoIcon"
    />
  );
};

export default V2LogoIcon;
